import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
.Dialog {
  max-width: 720px;
}

.title {
  font-size: 19px;
  color: ${colors.primaryText};
  margin-bottom: 14px;
  font-weight: 800;
}

.subtitle {
  font-size: 16px;
  color: ${colors.textHoverPurple};
  margin-bottom: 24px;
  font-weight: 400;
}

.supplementary-text {
  color: ${colors.tertiaryText};
  font-size: 14px;
}

.Dialog :global(a),
.Dialog :global(a:link),
.Dialog :global(a:visited),
.Dialog :global(a:active) {
  color: ${colors.textHoverPurple};
}

.Dialog :global(a:hover),
.Dialog :global(a:focus) {
  text-decoration: underline;
}

@media (min-width: 600px) {
  .title {
    font-size: 22px;
    margin-bottom: 16px;
  }

  .supplementary-text {
    font-size: 20px;
  }
}

@media (min-width: 768px) {
  .title {
    font-size: 36px;
    margin-bottom: 18px;
  }
  .subtitle {
    font-size: 22px;
    margin-bottom: 32px;
  }
}

@media (min-width: 1024px) {
  .title {
    font-size: 42px;
    margin-bottom: 24px;
  }
  .subtitle {
    font-size: 27px;
    margin-bottom: 40px;
  }
}
`
